module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-9.319a953f.png";